import { type App, defineAsyncComponent } from 'vue'

const components = {
  DeliverableEditorPage: defineAsyncComponent(() => import('../pages/DeliverableEditorPage.vue')),
  CanvasArtboard: defineAsyncComponent(() => import('./CanvasArtboard.vue')),
  CanvasAssetLibrary: defineAsyncComponent(() => import('./CanvasAssetLibrary.vue')),
  CanvasChatPanel: defineAsyncComponent(() => import('./CanvasChatPanel.vue')),
  CanvasDirectionsCard: defineAsyncComponent(() => import('./CanvasDirectionsCard.vue')),
  CanvasLooksCard: defineAsyncComponent(() => import('./CanvasLooksCard.vue')),
  CanvasLooksGallery: defineAsyncComponent(() => import('./CanvasLooksGallery.vue')),
  CanvasRenderRow: defineAsyncComponent(() => import('./CanvasRenderRow.vue')),
  CanvasSlidePreview: defineAsyncComponent(() => import('./CanvasSlidePreview.vue')),
  CanvasBottomBar: defineAsyncComponent(() => import('./CanvasBottomBar.vue')),
  CanvasImageChatButton: defineAsyncComponent(() => import('./CanvasImageChatButton.vue')),
  CanvasInspector: defineAsyncComponent(() => import('./CanvasInspector.vue')),
  CanvasStage: defineAsyncComponent(() => import('./CanvasStage.vue')),
  CanvasStaleNotice: defineAsyncComponent(() => import('./CanvasStaleNotice.vue')),
  CanvasSwatchRow: defineAsyncComponent(() => import('./CanvasSwatchRow.vue')),
  CanvasToolPanel: defineAsyncComponent(() => import('./CanvasToolPanel.vue')),
  CanvasTextEditor: defineAsyncComponent(() => import('./CanvasTextEditor.vue')),
  CanvasToolRail: defineAsyncComponent(() => import('./CanvasToolRail.vue')),
  CopyDocumentPanel: defineAsyncComponent(() => import('./CopyDocumentPanel.vue')),
  CopyIdeasCard: defineAsyncComponent(() => import('./CopyIdeasCard.vue')),
  CopyOfferCard: defineAsyncComponent(() => import('./CopyOfferCard.vue')),
  CopySection: defineAsyncComponent(() => import('./CopySection.vue')),
  CopyStage: defineAsyncComponent(() => import('./CopyStage.vue')),
  CopyVoiceLine: defineAsyncComponent(() => import('./CopyVoiceLine.vue')),
  PostShapeLine: defineAsyncComponent(() => import('./PostShapeLine.vue')),
  ReferenceRow: defineAsyncComponent(() => import('./ReferenceRow.vue')),
  CopyWriteRow: defineAsyncComponent(() => import('./CopyWriteRow.vue')),
  CopyWroteLink: defineAsyncComponent(() => import('./CopyWroteLink.vue')),
  DeliverableDetailsForm: defineAsyncComponent(() => import('./DeliverableDetailsForm.vue')),
  DeliverableDetailsPanel: defineAsyncComponent(() => import('./DeliverableDetailsPanel.vue')),
  DeliverableSchedulePicker: defineAsyncComponent(() => import('./DeliverableSchedulePicker.vue')),
  ExportPanel: defineAsyncComponent(() => import('./ExportPanel.vue')),
  EditorActionBar: defineAsyncComponent(() => import('./EditorActionBar.vue')),
  EditorHeader: defineAsyncComponent(() => import('./EditorHeader.vue')),
  ImageChatPanel: defineAsyncComponent(() => import('./ImageChatPanel.vue')),
  ImageProposalCard: defineAsyncComponent(() => import('./ImageProposalCard.vue')),
  ImageReferenceEditor: defineAsyncComponent(() => import('./ImageReferenceEditor.vue')),
  SlideFrameCard: defineAsyncComponent(() => import('./SlideFrameCard.vue')),
  SlidePreview: defineAsyncComponent(() => import('./SlidePreview.vue')),
  StageSwitcher: defineAsyncComponent(() => import('./StageSwitcher.vue'))
}

type Registry = typeof components

declare module 'vue' {
  interface GlobalComponents extends Registry {}
}

export const registerComponents = (app: App) => {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component)
  }
}
